import { css } from '@emotion/css';
import { colors } from '@/colors';
import { primary, primaryDark, N0, N50, N400 } from '@/colors/colorsV1';

export const styTextWrapper = (props) => css`
  display: block;
  position: relative;
  margin: 0;
  width: ${props.block ? '100%' : 'fit-content'};
`;

export const styTextInput = (props) => css`
  box-sizing: border-box;
  outline: none;

  width: 299px;
  height: 40px;
  padding: 12px 16px;
  border: 1px solid ${props.borderColor || colors.NEUTRAL_3};
  border-radius: 4px;
  background: ${colors.NEUTRAL_0};
  color: ${colors.NEUTRAL_10};
  font-weight: 400;

  &::placeholder {
    color: ${colors.NEUTRAL_4};
  }

  ${props.block &&
  `
    display: block;
    width: 100%;
  `}
  ${props.size === 'sm' &&
  `
    height: 30px;
    padding: 8px 8px;
  `}
  ${props.bold && 'font-weight: 700;'}
  ${props.error && `border: 1px solid ${colors.RED_6};`}

  ${props.disabled
    ? `
        background: ${colors.NEUTRAL_2};
        cursor: inherit;
      `
    : `
        &:focus {
          border: 1px solid ${props.error ? colors.RED_6 : colors.AJAIB_BLUE_5};
        }
      `}

  ${props.append &&
  `
    padding-right: ${props.appendPadding}px;
  `}  
  ${props.prepend &&
  `
    padding-left: ${props.prependPadding}px;
  `}
`;

export const styTextAppend = (props) => css`
  display: flex;
  align-items: center;
  position: absolute;
  top: 0px;
  right: 0px;

  box-sizing: border-box;
  height: 40px;
  padding: 8px 12px 8px 4px;
  font-weight: bold;

  ${props.size === 'sm' &&
  `
    height: 30px;
    padding: 8px 8px 8px 4px;
  `}
  ${props.appendClick ? `cursor: pointer;` : `pointer-events: none;`}
`;

export const styTextPrepend = (props) => css`
  display: flex;
  align-items: center;
  position: absolute;
  top: 0px;
  left: 0px;

  box-sizing: border-box;
  height: 40px;
  padding: 8px 4px 8px 12px;
  font-weight: bold;

  ${props.size === 'sm' &&
  `
    height: 30px;
    padding: 8px 4px 8px 8px;
  `}
  ${props.prependClick ? `cursor: pointer;` : `pointer-events: none;`}
`;

export const styNumberBorderBottom = (props) => css`
  box-sizing: border-box;
  outline: none;

  width: 299px;
  height: 40px;
  padding: 8px 0px;
  border: none;
  border-bottom: 1px solid ${props.borderColor || colors.NEUTRAL_3};
  background: ${colors.NEUTRAL_0};
  color: ${colors.NEUTRAL_10};
  font-size: 17px;
  font-weight: 700;

  // Disable spinners
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type='number'] {
    appearance: textfield;
    -moz-appearance: textfield;
  }

  &::placeholder {
    color: ${colors.NEUTRAL_4};
  }

  ${props.block &&
  `
    display: block;
    width: 100%;
  `}
  ${props.size === 'sm' &&
  `
    height: 30px;
    padding: 8px 0px;
  `}
  ${props.bold && 'font-weight: 700;'}
  ${props.error && `border-bottom: 1px solid ${colors.RED_6};`}

  ${props.disabled
    ? `
        background: ${colors.NEUTRAL_2};
        cursor: inherit;
      `
    : `
        &:focus {
          border-bottom: 1px solid
            ${props.error ? colors.RED_6 : colors.AJAIB_BLUE_5};
        }
      `}

  ${props.append &&
  `
    padding-right: ${props.appendPadding}px;
  `}  
  ${props.prepend &&
  `
    padding-left: ${props.prependPadding}px;
  `}
`;

export const styInputSpinner = (props) => css`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  border: solid 1px ${props.error ? colors.RED_6 : colors.NEUTRAL_3};
  border-radius: 4px;

  input {
    width: 100%;
    flex-grow: 1;
    border: none;
    text-align: center;
    padding: 4px 0px;
    outline: none;
  }

  button {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 38px;
    height: 38px;
    padding: 9px;
    background: transparent;
    border: none;
    border-radius: 4px;
    outline: none;
    cursor: pointer;

    ${props.size === 'sm' &&
    `
      width: 28px;
      height: 28px;
      padding: 4px;
    `};

    :hover,
    :focus,
    :active {
      background: ${colors.AJAIB_BLUE_1};
    }

    svg {
      path,
      circle {
        fill: ${colors.NEUTRAL_10};
        stroke: ${colors.NEUTRAL_10};
      }
    }
  }
`;

export const styDateWrapper = (props) => css`
  display: block;
  position: relative;
  margin: 0;

  .react-datepicker-wrapper {
    width: ${props.block ? '100%' : 'fit-content'};
  }

  .react-datepicker__aria-live {
    /* TODO: this is inserted due to a bug on react-datepicker@4.11.0 */
    /* See more on https://github.com/Hacker0x01/react-datepicker/issues/3924 */
    display: none;
  }
`;

export const styCheckboxWrapper = (props) => css`
  box-sizing: border-box;
  font-size: 14px;
  margin: 0;
  padding: 0;
  color: ${props.disabled ? colors.NEUTRAL_4 : colors.NEUTRAL_10};
  display: inline-flex;
  align-items: center;
  cursor: ${props.disabled ? 'inherit' : 'pointer'};

  :after {
    display: inline-block;
    width: 0;
    overflow: hidden;
    content: '\a0';
  }
`;

export const styCheckboxOuter = css`
  box-sizing: border-box;
  margin: -2px 6px -2px -2px;
  padding: 2px;
  list-style: none;
  position: relative;
  white-space: nowrap;
`;

export const styCheckboxInput = css`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  cursor: inherit;
  opacity: 0;
`;

export const styCheckboxInner = (props) => css`
  position: relative;
  top: 0;
  left: 0;
  display: block;
  width: 16px;
  height: 16px;
  direction: ltr;
  border-radius: 4px;
  border-collapse: separate;
  transition: all 0.3s;

  ${props.disabled
    ? `
        background-color: ${props.checked ? primaryDark : N50};
        border: 1px solid ${props.checked ? primaryDark : N400};
      `
    : `
        background-color: ${props.checked ? primary : N0};
        border: 1px solid ${props.checked ? primaryDark : N400};
      `}

  :after {
    content: '';
    position: absolute;
    border: 2px solid ${N0};
    border-top: 0;
    border-left: 0;
    opacity: 0;
    transform: rotate(45deg) scale(${props.checked ? 1 : 0}) translate(-50%, -50%);

    ${props.checked &&
    `
      opacity: 1;
      left: 3px;
      top: 7px;
      width: 6px;
      height: 8px;
    `}
  }
`;

export const styRadioWrapper = (props) => css`
  box-sizing: border-box;
  font-size: 14px;
  margin: 0;
  ${props.flexDirection === 'row' && 'margin-right: 8px;'}
  ${props.flexDirection === 'column' && 'margin-bottom: 8px;'}
  color: ${props.color || `${colors.NEUTRAL_10}`};
  padding: 0;
  display: inline-flex;
  align-items: center;
  cursor: pointer;

  ${props.disabled &&
  `
    color: ${colors.NEUTRAL_4};
    cursor: not-allowed;
  `}

  :after {
    display: inline-block;
    width: 0;
    overflow: hidden;
    content: '\a0';
  }
`;

export const styRadioOuter = (props) => css`
  box-sizing: border-box;
  height: 18px;
  width: 18px;
  background-color: transparent;
  border: 2px solid ${colors.NEUTRAL_4};
  border-radius: 50%;
  margin-right: 4px;
  list-style: none;
  position: relative;
  white-space: nowrap;
  outline: none;

  ${props.checked &&
  `
    border: 2px solid ${colors.AJAIB_BLUE_5};

    ::before {
      content: '';
      display: block;
      position: absolute;
      height: calc(100% - 4px);
      width: calc(100% - 4px);
      margin: 2px;
      background: ${colors.AJAIB_BLUE_5};
      border-radius: 50%;
    }
  `}

  ${props.disabled &&
  `
    border: 2px solid ${colors.NEUTRAL_2};

    ::before {
      background: ${colors.NEUTRAL_2};
    }
  `}

  > input {
    height: 18px;
    width: 18px;
    margin: -2px;
    opacity: 0;
    cursor: inherit;
  }
`;

export const stySelectWrapper = () => css`
  position: relative;
  margin: 0;
  padding: 0;
  display: inline-block;
  width: 100%;
`;

export const stySelectSelector = ({ disabled, error, unselected }) => css`
  display: flex;
  box-sizing: border-box;
  width: 100%;
  height: 32px;

  padding: 0 8px;
  border: 1px solid ${unselected ? colors.AJAIB_BLUE_5 : colors.NEUTRAL_3};
  border-radius: 4px;
  background: ${colors.NEUTRAL_0};
  color: ${colors.NEUTRAL_10};
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);

  ${error && `border: 1px solid ${colors.RED_6};`}
  ${disabled &&
  `
    cursor: not-allowed;
    background-color: ${colors.NEUTRAL_2};
  `}
`;

export const stySelectSelectorInner = ({ value }) => css`
  flex: 1;
  display: flex;
  align-items: center;

  padding: 0;
  line-height: 30px;
  transition: all 0.3s;

  text-align: left;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  ${!value && `color: ${colors.NEUTRAL_4};`}

  img {
    height: 16px;
    width: 16px;
    &:first-child {
      margin-right: 4px;
    }
  }
`;

export const stySelectIcon = ({ isOpen }) => css`
  position: absolute;
  right: 11px;

  display: flex;
  align-self: center;
  width: 16px;
  height: 16px;

  transition: all 0.3s;
  transform: rotate(0deg);

  ${isOpen && 'transform: rotate(180deg);'}
`;

export const stySelectOptionsContainer = ({ isOpen, optionsContainerHeight }) => css`
  position: absolute;
  display: none;
  z-index: 2;
  width: 100%;

  background-color: ${colors.NEUTRAL_0};
  border: 1px solid ${colors.NEUTRAL_3};
  border-radius: 4px;
  box-shadow: rgb(51 51 51 / 16%) 2px 2px 6px 0px;

  ${isOpen && 'display: block;'}

  > *:last-child {
    ${{ height: optionsContainerHeight }}
    overflow-y: scroll;
  }
`;

export const stySelectOptionItem = ({ disabled, variant }) => css`
  padding: 8px;
  text-align: left;
  cursor: pointer;
  transition: all 0.3s;

  ${variant === 'default' &&
  `
    display: flex;
    align-items: center;

    img {
      height: 15px;
      width: 15px;
      &:first-child {
        margin-right: 4px;
      }
    }
  `};

  ${disabled
    ? `
        color: ${colors.NEUTRAL_4} !important;
        background-color: ${colors.NEUTRAL_2} !important;
        cursor: not-allowed;
      `
    : `
      :hover,
      :active,
      :focus,
      &.selected {
        color: ${colors.AJAIB_BLUE_5} !important;
        background-color: ${colors.AJAIB_BLUE_1} !important;
      }
    `}
`;

export const styInputSearch = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  box-sizing: border-box;
  width: 100%;
  height: 40px;
  padding: 4px 8px;

  color: ${colors.NEUTRAL_10};
  background-color: ${colors.NEUTRAL_0};
  border-bottom: 1px solid ${colors.NEUTRAL_3};

  input {
    border: none;
    outline: none;
    width: 80%;

    &::placeholder {
      color: ${colors.NEUTRAL_4};
    }
  }

  svg {
    height: 20px;
    width: 20px;
  }
`;
